export default "__VITE_ASSET__DC5r5hZW__"